/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_rna_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNA output (U)`)
};

const es_revcomp_rna_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salida en ARN (U)`)
};

const de_revcomp_rna_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNA-Ausgabe (U)`)
};

const nl_revcomp_rna_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNA-uitvoer (U)`)
};

const fr_revcomp_rna_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortie ARN (U)`)
};

const it_revcomp_rna_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output RNA (U)`)
};

const pt_br2_revcomp_rna_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saída em RNA (U)`)
};

const pt_revcomp_rna_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saída em ARN (U)`)
};

const ja_revcomp_rna_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNA出力 (U)`)
};

const zh_revcomp_rna_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNA 输出（U）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_rna_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_rna_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_rna_label", locale)
	if (locale === "en") return en_revcomp_rna_label(inputs)
	if (locale === "es") return es_revcomp_rna_label(inputs)
	if (locale === "de") return de_revcomp_rna_label(inputs)
	if (locale === "nl") return nl_revcomp_rna_label(inputs)
	if (locale === "fr") return fr_revcomp_rna_label(inputs)
	if (locale === "it") return it_revcomp_rna_label(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_rna_label(inputs)
	if (locale === "pt") return pt_revcomp_rna_label(inputs)
	if (locale === "ja") return ja_revcomp_rna_label(inputs)
	return zh_revcomp_rna_label(inputs)
};